<template>
  <div class="project wid100">
    <div class="list">
      <div class="swiper-container mySwiper " ref="Node"  v-for="Home in HomeList" :key="Home.id"  >
        <div class="swiper-wrapper">
          <div class="swiper-slide"  v-for="d in Home.workMap" :key="d.id">
            <video controls="controls" muted v-if="d.type =='m4v' || d.type =='mp4'" class="wid100" :src="d.url"></video>
            <img v-if="d.type =='jpg' || d.type =='png'|| d.type =='gif'" :src="d.url" class="wid100":alt="Home.content">
            <p v-if="Home.workType!=2"><img src="https://cyvideo.i-oranges.com/home/19.png"  @click="workTypes(Home.workType, Home.id, Home.link)"></p>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 导航按钮 -->
        <div class="swiper-button-prev add_button-prev"></div>
        <div class="swiper-button-next add_button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { officialHome } from '@/api/article'
import Swiper from "swiper";

export default {
  name: "ProjectComponent",
  data() {
    return {
      HomeList: [],
      mySwiper: null, // 用于保存Swiper实例

    }
  },
  methods: {
    workTypes(type, id, url) {
      if (type < 1 && url) {
        window.open(url)
      } else if (type ===1) {
        this.$router.push({ path: '/article/', query: { id: `${id}` } })
      }else {
        // console.log("不跳转");
      }
    },
    initSwiper() {
      let thatVideo='';
      this.mySwiper = new Swiper('.mySwiper', {
        loop: false, // 循环模式
        pagination: {
          el: '.swiper-pagination', // 分页器
          clickable: true,
        },
        on:{
          slideChangeTransitionEnd: function(){

            let element = this.slides[this.activeIndex].children[0];
            if (element.tagName === 'VIDEO') {
              element.play()
              thatVideo = element;
            }else{
              thatVideo.pause()
            }
          }
        },
        navigation: {
          nextEl: '.swiper-button-next', // 下一页按钮
          prevEl: '.swiper-button-prev', // 上一页按钮
        },
      });
    },
  },
  mounted() {
    let that = this;
    officialHome().then(res => {
      this.HomeList = res.data;
      setTimeout(function (){
        that.initSwiper();
      },1000)

    })



  }
}
</script>

<style scoped>
.project {
  background: #141414;
}
.mySwiper{}
.list{width: 100%; margin: 0 auto;}
.project img {
  vertical-align: middle;
  cursor: pointer;
  margin-bottom: 2px;
}
.list_item {
  width: 100%;
  background: #fff;
  padding: 30px 0;
}
.list_item .item {
  width: 90%;
  margin: 0 auto;
}
.list_item span {
  margin: 10px 5px;
  font-size: 20px;
  letter-spacing: 1px;
  color: #808080;
  border: 2px solid #808080;
  padding: 3px 30px;
  border-radius: 30px;
  cursor: pointer;
  display: inline-block;
}
.list_item span.active {
  background: #ff6600;
  border: 2px solid #ff6600;
  color: #fff;
}
.mySwiper{margin: 0 0 5% 5%; width:90%;}
.swiper-slide{text-align: center; position: relative; padding-bottom: 30px;}
.mySwiper:hover p{opacity: 1}
.swiper-slide p{width: 84.5%; height: 25px; position: absolute;transition: all .5s; bottom: 5px; left: 7.75%; text-align: right; opacity: 0;}
.swiper-slide p img{width: 6% !important;
   height: 25px !important;}
.swiper-wrapper .swiper-slide img,.swiper-wrapper .swiper-slide video{width: 84.5%; margin: 0 auto;}
.add_button-prev{ background: url("https://cyvideo.i-oranges.com/home/left1.png")center no-repeat; background-size: 100%; left: 70px; transition: transform 0.3s ease;}
.add_button-prev,.add_button-next{width: 30px; }
.add_button-prev:after{display: none}
.add_button-next{ background: url("https://cyvideo.i-oranges.com/home/right1.png")center no-repeat; background-size: 100%; right:70px; transition: transform 0.3s ease;}
.add_button-next:after{display: none}
.add_button-next:hover{transform: scale(1.3); }
.add_button-prev:hover{transform: scale(1.3); }
</style>
<style>
.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled{
  opacity: 0 !important;
  transition: all 0.5s;
}

</style>



// WEBPACK FOOTER //
// src/components/ProjectComponentIndex.vue